import React from 'react';
import { EuiPanel, EuiPanelProps } from '@elastic/eui';

export default ({ hasShadow = false, ...props }: EuiPanelProps) => (
  <EuiPanel {...props} borderRadius={'none'} hasShadow={hasShadow} />
);
